import React from 'react';

const FMT = (n) => n?.toLocaleString('fr-DZ') || '0';

export default function ExportResults({ R, lang }) {
  const ar = lang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const date = new Date().toLocaleDateString('fr-FR');

  return (
    <div className="results-fade-in">
      {/* 1. Code SH */}
      <div className="card">
        <div className="card-title">🏷️ {L('Classification tarifaire export','التصنيف الجمركي للتصدير')}</div>
        <div style={{ display:'flex', gap:'0.35rem', flexWrap:'wrap', marginBottom:'0.5rem' }}>
          <span className="badge badge-blue">{R.hsCode}</span>
          <span className="badge badge-green">{L('Confiance','الثقة')} {R.confidence}%</span>
          <span className="badge" style={{ background:'rgba(124,58,237,0.15)', color:'#818cf8' }}>🤖 IA</span>
        </div>
        <p style={{ fontSize:'0.85rem', marginBottom:'0.3rem' }}><strong>{R.description}</strong></p>
        {R.explanation && <div className="alert alert-info" style={{ fontSize:'0.78rem' }}><span>💡</span><div>{R.explanation}</div></div>}
        <div style={{ fontSize:'0.72rem', color:'var(--muted)', marginTop:'0.3rem' }}>{L('Code valable pour l\'export depuis l\'Algérie et la déclaration DUA export.','رمز صالح للتصدير من الجزائر وتصريح DUA للتصدير.')}</div>
      </div>

      {/* 2. Contrôle export */}
      <div className={`alert ${R.exportControl?.isFree ? 'alert-success' : 'alert-danger'}`} style={{ fontSize:'0.85rem' }}>
        <span>{R.exportControl?.isFree ? '✅' : '🚫'}</span>
        <div>
          <strong>{R.exportControl?.isFree ? L('Exportation libre — Aucune restriction','تصدير حر — لا قيود') : L('Produit soumis à restriction','منتج خاضع لقيود')}</strong>
          {R.exportControl?.restrictions && <><br/>{R.exportControl.restrictions}</>}
          {R.exportControl?.requiresLicense && <><br/>📋 {L('Licence requise auprès de','ترخيص مطلوب من')} : {R.exportControl.licenseAuthority}</>}
        </div>
      </div>

      {/* 3. Accord préférentiel */}
      {R.preferentialAccess?.applicable && (
        <div className="card">
          <div className="card-title">🌍 {L('Avantage pour votre acheteur','ميزة للمشتري')}</div>
          <div className="alert alert-success" style={{ fontSize:'0.82rem' }}>
            <span>📜</span>
            <div>
              <strong>{R.preferentialAccess.accordName}</strong><br/>
              {L('Droits normaux','الرسوم العادية')} : <strong>{R.preferentialAccess.buyerTariffNormal}%</strong> → {L('Avec accord','مع الاتفاقية')} : <strong>{R.preferentialAccess.buyerTariffWithAccord}%</strong><br/>
              <span style={{ fontSize:'0.9rem', fontWeight:700, color:'#10b981' }}>💰 {L('Économie acheteur','توفير المشتري')} : {R.preferentialAccess.buyerSaving}</span>
            </div>
          </div>
          <div className="doc-mentions" style={{ marginTop:'0.5rem' }}>
            <div className="doc-mentions-title">📋 {L('Pour en bénéficier','للاستفادة')}</div>
            <ul>
              <li><strong>{L('Document','الوثيقة')} :</strong> {R.preferentialAccess.originDocumentRequired}</li>
              <li><strong>{L('Règle d\'origine','قاعدة المنشأ')} :</strong> {R.preferentialAccess.originRule}</li>
            </ul>
          </div>
          {R.preferentialAccess.competitiveAdvantage && (
            <div className="alert alert-info" style={{ marginTop:'0.5rem', fontSize:'0.78rem' }}><span>💼</span><div><strong>{L('Argument commercial','الحجة التجارية')} :</strong> {R.preferentialAccess.competitiveAdvantage}</div></div>
          )}
          {R._isProducteur === false && <div className="alert alert-warning" style={{ marginTop:'0.3rem', fontSize:'0.78rem' }}><span>⚠️</span><div>{L('EUR.1 non accessible aux négociants — réservé aux producteurs.','EUR.1 غير متاح للتجار — مخصص للمنتجين.')}</div></div>}
        </div>
      )}

      {/* 4. Documents 2 colonnes */}
      <div className="card">
        <div className="card-title">📄 {L('Documents à préparer','الوثائق المطلوبة')}</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
          <div>
            <div className="doc-phase">🇩🇿 {L('Documents algériens','الوثائق الجزائرية')}</div>
            <ul className="doc-list">{(R.algerianDocuments || []).map((d, i) => (
              <li key={i} className="doc-item"><span className="doc-icon">{d.mandatory ? '✅' : '📌'}</span><div>
                <strong>{d.name}</strong>
                <span className="badge badge-blue" style={{ marginInlineStart:'0.3rem', fontSize:'0.63rem' }}>{d.timing?.replace(/_/g,' ')}</span>
                <div className="doc-details">{d.issuer} {d.delayDays && `— ${d.delayDays}`}</div>
                {d.criticalMentions?.length > 0 && <div className="doc-mentions"><div className="doc-mentions-title">📋 {L('Mentions obligatoires','البيانات الإلزامية')}</div><ul>{d.criticalMentions.map((m,j) => <li key={j}>{m}</li>)}</ul></div>}
                {d.howToObtain && <div className="doc-howto">→ {d.howToObtain}</div>}
                {d.notes && <div className="doc-details" style={{ marginTop:'0.2rem' }}>💡 {d.notes}</div>}
              </div></li>
            ))}</ul>
          </div>
          <div>
            <div className="doc-phase">🌐 {L(`Exigences ${R._paysNom}`,`متطلبات ${R._paysNom}`)}</div>
            <ul className="doc-list">{(R.destinationRequirements || []).map((d, i) => (
              <li key={i} className="doc-item"><span className="doc-icon">{d.mandatory ? '✅' : '📌'}</span><div>
                <strong>{d.name}</strong>
                <span className="badge badge-yellow" style={{ marginInlineStart:'0.3rem', fontSize:'0.63rem' }}>{d.type}</span>
                <div className="doc-details">{d.whyRequired}</div>
                {d.criticalMentions?.length > 0 && <div className="doc-mentions"><div className="doc-mentions-title">📋 {L('Mentions','البيانات')}</div><ul>{d.criticalMentions.map((m,j) => <li key={j}>{m}</li>)}</ul></div>}
                {d.howToObtain && <div className="doc-howto">→ {d.howToObtain}</div>}
              </div></li>
            ))}</ul>
            <div style={{ fontSize:'0.72rem', color:'var(--muted)', marginTop:'0.5rem', fontStyle:'italic' }}>
              {L('Fournir ces documents à votre acheteur avec la marchandise lui facilitera le dédouanement.','تقديم هذه الوثائق للمشتري مع البضاعة سيسهل عليه التخليص الجمركي.')}
            </div>
          </div>
        </div>
      </div>

      {/* 5. Mentions facture */}
      {R.invoiceMentions && (
        <div className="card">
          <div className="card-title">🧾 {L('Mentions obligatoires facture export','البيانات الإلزامية لفاتورة التصدير')}</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
            <div>
              <h4 style={{ fontSize:'0.78rem', marginBottom:'0.3rem' }}>🇫🇷 Français</h4>
              <div className="doc-mentions"><ul>{(R.invoiceMentions.mandatoryFR || []).map((m,i) => <li key={i}>{m}</li>)}</ul></div>
            </div>
            <div>
              <h4 style={{ fontSize:'0.78rem', marginBottom:'0.3rem' }}>🇬🇧 English</h4>
              <div className="doc-mentions"><ul>{(R.invoiceMentions.mandatoryEN || []).map((m,i) => <li key={i}>{m}</li>)}</ul></div>
            </div>
          </div>
        </div>
      )}

      {/* 6. Aides export */}
      {R.algexFSPESupport && (R.algexFSPESupport.fspeEligible || R.algexFSPESupport.algexServices?.length > 0) && (
        <div className="card">
          <div className="card-title">🏛️ {L('Aides à l\'export','المساعدات للتصدير')}</div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'0.6rem' }}>
            {R.algexFSPESupport.fspeEligible && (
              <div style={{ background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.2)', borderRadius:12, padding:'0.8rem' }}>
                <div style={{ fontWeight:700, fontSize:'0.85rem', marginBottom:'0.2rem' }}>💰 FSPE</div>
                <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>{L('Prime export','علاوة التصدير')} : <strong>{R.algexFSPESupport.fspeRate}</strong></div>
                {R._prix && <div style={{ fontSize:'0.82rem', color:'#10b981', fontWeight:700, marginTop:'0.2rem' }}>≈ {FMT(Math.round(parseFloat(R._prix) * R._tauxChange * 0.04))} DZD</div>}
                <div style={{ fontSize:'0.7rem', color:'var(--muted)', marginTop:'0.2rem' }}>{R.algexFSPESupport.fspeConditions}</div>
              </div>
            )}
            {R.algexFSPESupport.algexServices?.length > 0 && (
              <div style={{ background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.2)', borderRadius:12, padding:'0.8rem' }}>
                <div style={{ fontWeight:700, fontSize:'0.85rem', marginBottom:'0.2rem' }}>🏢 ALGEX</div>
                <ul style={{ fontSize:'0.75rem', color:'var(--muted)', paddingInlineStart:'1rem' }}>{R.algexFSPESupport.algexServices.map((s,i) => <li key={i}>{s}</li>)}</ul>
              </div>
            )}
            {R.algexFSPESupport.cagexInsurance && (
              <div style={{ background:'rgba(245,158,11,0.08)', border:'1px solid rgba(245,158,11,0.2)', borderRadius:12, padding:'0.8rem' }}>
                <div style={{ fontWeight:700, fontSize:'0.85rem', marginBottom:'0.2rem' }}>🛡️ CAGEX</div>
                <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>{L('Assurance-crédit export — garantie impayé acheteur','تأمين ائتمان التصدير — ضمان عدم دفع المشتري')}</div>
              </div>
            )}
            {R.algexFSPESupport.taxExemptions && (
              <div style={{ background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.2)', borderRadius:12, padding:'0.8rem' }}>
                <div style={{ fontWeight:700, fontSize:'0.85rem', marginBottom:'0.2rem' }}>🏦 {L('Exonérations','إعفاءات')}</div>
                <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>{R.algexFSPESupport.taxExemptions}</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 7. Packaging */}
      {R.packagingAndLabeling && (
        <div className="card">
          <div className="card-title">📦 {L('Étiquetage et packaging','الوسم والتغليف')}</div>
          <p style={{ fontSize:'0.82rem', marginBottom:'0.4rem' }}><strong>{L('Langue(s)','اللغة(ات)')} :</strong> {R.packagingAndLabeling.destinationLanguage}</p>
          {R.packagingAndLabeling.mandatoryMentions?.length > 0 && <div className="doc-mentions"><div className="doc-mentions-title">📋 {L('Mentions emballage','بيانات التغليف')}</div><ul>{R.packagingAndLabeling.mandatoryMentions.map((m,i) => <li key={i}>{m}</li>)}</ul></div>}
          {R.packagingAndLabeling.normsToRespect?.length > 0 && <div style={{ marginTop:'0.4rem' }}><strong style={{ fontSize:'0.78rem' }}>{L('Normes','المعايير')} :</strong> <span style={{ display:'inline-flex', gap:'0.2rem', flexWrap:'wrap' }}>{R.packagingAndLabeling.normsToRespect.map((n,i) => <span key={i} className="badge badge-blue">{n}</span>)}</span></div>}
          {R.packagingAndLabeling.specificRequirements && <div className="doc-warning" style={{ marginTop:'0.3rem' }}>⚠️ {R.packagingAndLabeling.specificRequirements}</div>}
        </div>
      )}

      {/* 8. Paiement */}
      <div className="card">
        <div className="card-title">💳 {L('Mode de paiement recommandé','طريقة الدفع الموصى بها')}</div>
        <div className="alert alert-info" style={{ fontSize:'0.82rem' }}>
          <span>💰</span>
          <div>
            <strong>{R.paymentRecommendation?.recommended}</strong><br/>
            {R.paymentRecommendation?.reason}<br/>
            <span className={`badge ${R.paymentRecommendation?.riskLevel === 'faible' ? 'badge-green' : R.paymentRecommendation?.riskLevel === 'élevé' ? 'badge-red' : 'badge-yellow'}`}>
              {L('Risque','المخاطر')} : {R.paymentRecommendation?.riskLevel}
            </span>
            {R.paymentRecommendation?.devisesRapatriement && <><br/><span style={{ fontSize:'0.72rem', color:'var(--muted)' }}>⏱️ {R.paymentRecommendation.devisesRapatriement}</span></>}
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="disclaimer">
        <strong>⚠️ {L('Avertissement','تحذير')} — {date}</strong><br/>
        {L('Informations indicatives basées sur la réglementation en vigueur. Vérifiez auprès de la DGD (douane.gov.dz), ALGEX (algex.dz) ou votre transitaire.',
           'معلومات إرشادية مبنية على التنظيم الساري. تحقق من المديرية العامة للجمارك (douane.gov.dz) أو ALGEX (algex.dz) أو وكيلك الجمركي.')}
      </div>
    </div>
  );
}
